var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as R from 'ramda';
import Moment from 'moment';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { Calendar } from 'primereact/calendar';
// const DIVIDERS = 'юб\.\,\-\/';
// const MASK = [/[\d]/,/[\d]/, /[.]/, /[\d]/,/[\d]/, /[.]/, /[\d]/,/[\d]/,/[\d]/,/[\d]/ ];
var DATE_FORMAT = 'DD.MM.YYYY';
var DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
var ru = {
    firstDayOfWeek: 1,
    dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    monthNamesShort: ['янв', 'фев', 'мрт', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'нбр', 'дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'dd.mm.yy',
    weekHeader: 'Sm'
};
var mapMomentDate = function (dt, hasTime) { return Moment(dt, (hasTime ? [DATE_TIME_FORMAT, DATE_FORMAT] : DATE_FORMAT), true); };
var fromatDate = function (dt, hasTime) { return Moment(dt).format((hasTime ? DATE_TIME_FORMAT : DATE_FORMAT)); };
var testFullDateValue = function (dt) {
    return /^(?:(?:31(\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})(?:[ ]([0-1]\d|2[0-3])[\:][0-5]\d)?$/.test(dt);
};
// const testInputDateValue = (dt: string) => !!dt && dt.split('').every((v, idx) =>
//   idx > MASK.length-1 ? false : new RegExp(MASK[idx], 'g').test(v)
// );
// const clearDateValue = (dt: string) => dt ? dt.replace(new RegExp(`[${DIVIDERS}]`, 'g'), '.').replace(/ /g, '') : dt;
var DateControl = /** @class */ (function (_super) {
    __extends(DateControl, _super);
    function DateControl(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = null;
        _this.resetRendered = true;
        _this.handleChange = function (evt) {
            var resValue = '';
            var showTime = R.path(['def', 'frontOptions', 'showTime'], _this.state);
            var selectionMode = R.path(['def', 'frontOptions', 'selectionMode'], _this.state);
            var value = evt.value || '';
            if (_this.ref) {
                if (!value || value instanceof Date) {
                    if (!showTime) { // если дата или пусто
                        _this.ref.hideOverlay();
                    }
                    var next = !!value ? fromatDate(value, showTime) : '';
                    resValue = next;
                    if (next !== _this.state.date) {
                        _this.onInputComplete(next);
                    }
                }
                if (selectionMode === 'range') {
                    resValue = evt.value;
                }
                else if (!!_this.state.date && value.length < _this.state.date.length) { // если стерли символ
                    resValue = evt.value;
                }
                else { // если ввели символ
                    var numOfLastSymbol = value.length - 1;
                    var lastSymbol = !value ? '' : value[numOfLastSymbol];
                    var format = showTime ? DATE_TIME_FORMAT : DATE_FORMAT;
                    if (numOfLastSymbol < format.length) {
                        var formatSymbols = R.pipe(R.split(''), R.addIndex(R.map)(function (val, idx) { return ({ index: idx, symbol: val }); }), R.filter(function (s) { return (/[^DMYHhm]/).test(s.symbol); }))(format);
                        var formatSymbol = R.find(R.propEq('index', numOfLastSymbol))(formatSymbols);
                        if (!!formatSymbol) {
                            if (lastSymbol === formatSymbol.symbol) {
                                resValue = evt.value;
                            }
                            else if ((/[0-9]/).test(lastSymbol)) {
                                resValue = (_this.state.date || '') + formatSymbol.symbol + lastSymbol;
                            }
                        }
                        else if ((/[0-9]/).test(lastSymbol)) {
                            resValue = value;
                        }
                        if (value.length === format.length) {
                            _this.onInputComplete(value);
                        }
                    }
                }
                _super.prototype.handleChange.call(_this, resValue);
                _this.setState({ date: resValue });
            }
        };
        _this.handleBlur = function (evt) {
            _super.prototype.handleBlur.call(_this, evt);
            var value = evt.currentTarget && evt.currentTarget['value'] || fromatDate(evt.value);
            _this.onInputComplete(value, true);
        };
        _this.checkInternalError = R.cond([
            [function (x) { return !x; }, R.always(null)],
            [R.complement(testFullDateValue), R.always('Неверно указана дата!')],
            [function (val) { return _this.minDate && _this.minDate.diff(mapMomentDate(val, _this.showTime)) > 0; }, function () { return "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0430\u044F \u0434\u0430\u0442\u0430 " + fromatDate(_this.minDate) + "!"; }],
            [function (val) { return _this.maxDate && _this.maxDate.diff(mapMomentDate(val, _this.showTime)) < 0; }, function () { return "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0430\u044F \u0434\u0430\u0442\u0430 " + fromatDate(_this.maxDate) + "!"; }],
            [R.T, R.always(null)]
        ]);
        _this.state = __assign(__assign({}, _this.state), { internalError: null, date: _this.value, viewDate: Moment().toDate() });
        return _this;
    }
    DateControl.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var today = Moment();
        var viewDate = today;
        if (this.minDate && this.minDate.diff(today) > 0) {
            viewDate = this.minDate;
        }
        else if (this.maxDate && this.maxDate.diff(today) < 0) {
            viewDate = this.maxDate;
        }
        if (this.state.date) {
            viewDate = mapMomentDate(this.state.date);
        }
        this.setState({ viewDate: viewDate.toDate() });
    };
    DateControl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var prevValue = R.path(['value'], prevState);
        if (prevValue !== this.value) {
            this.setState({ date: this.value }, this.forceUpdate);
        }
    };
    Object.defineProperty(DateControl.prototype, "minDate", {
        get: function () {
            var minDate = R.path(['def', 'frontOptions', 'minDate'], this.state);
            return minDate && minDate.value !== undefined && minDate.unit ? Moment().add(minDate.value, minDate.unit).startOf('day') : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "minDateDate", {
        get: function () {
            return this.minDate && this.minDate.toDate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "maxDate", {
        get: function () {
            var maxDate = R.path(['def', 'frontOptions', 'maxDate'], this.state);
            return maxDate && maxDate.value !== undefined && maxDate.unit ? Moment().add(maxDate.value, maxDate.unit).endOf('day') : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "maxDateDate", {
        get: function () {
            return this.maxDate && this.maxDate.toDate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "yearRange", {
        get: function () {
            return (this.minDate ? this.minDate.year() : 1800) + " : " + (this.maxDate ? this.maxDate.year() : 2200);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "restAttrs", {
        get: function () {
            return R.pipe(R.pathOr({}, ['def', 'frontOptions']), R.omit(['minDate', 'maxDate']))(this.state);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "showTime", {
        get: function () {
            return !!R.path(['def', 'frontOptions', 'showTime'], this.state);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateControl.prototype, "dateValue", {
        get: function () {
            var date = this.state.date && this.state.date.length === (this.showTime ? DATE_TIME_FORMAT : DATE_FORMAT).length && mapMomentDate(this.state.date, this.showTime);
            return date && date.isValid() ? date.toDate() : null;
        },
        enumerable: false,
        configurable: true
    });
    DateControl.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !this.resetRendered || _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState) || !R.eqBy(R.pick(['internalError']), this.state, nextState);
    };
    DateControl.prototype.elementRender = function (def) {
        var _this = this;
        this.resetRendered = true;
        var _a = def.frontOptions, hint = _a.hint, label = _a.label, selectionMode = _a.selectionMode, placeholder = _a.placeholder, restOptions = __rest(_a, ["hint", "label", "selectionMode", "placeholder"]);
        var mode = selectionMode ? selectionMode : 'single';
        var date = this.dateValue;
        var dateFormat = (date || mode !== 'single') ? 'dd.mm.yy' : 'dd.mm.yyyy';
        var dateValue = date || this.state.date;
        var printLabel = label || def.label;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement(Calendar, __assign({ key: def.id, id: def.id, ref: function (ref) {
                    if (ref) {
                        _this.ref = ref;
                        _this.ref.inputElement.setAttribute('field-code', def.code);
                    }
                }, inputId: def.id, disabled: def.disabled, readOnlyInput: def.readonly, tooltip: hint }, this.restAttrs, { dateFormat: dateFormat, onChange: this.handleChange, value: dateValue, 
                // value={this.value}
                minDate: this.minDateDate, maxDate: this.maxDateDate, onBlur: this.handleBlur, onSelect: function (e) { return setTimeout(function () { return _this.handleBlur(e); }, 0); }, onFocus: this.handleFocus, yearNavigator: true, monthNavigator: true, yearRange: this.yearRange, locale: ru, viewDate: this.state.viewDate, onViewDateChange: function (e) { return _this.setState({ viewDate: e.value }, _this.forceUpdate); }, hourFormat: "24", selectionMode: mode, placeholder: placeholder || null })),
            React.createElement(ControlError, { error: this.state.internalError || this.error, touched: this.touched }));
    };
    DateControl.prototype.onInputComplete = function (value, reset) {
        if (reset === void 0) { reset = false; }
        var error = this.checkInternalError(value);
        if (!error && !!value) {
            this.setState({ viewDate: mapMomentDate(value, this.showTime).toDate() });
        }
        if (error && reset) {
            _super.prototype.handleChange.call(this, null);
            this.resetRendered = false;
        }
        else if (!reset) {
            // form event
            var target = this.state.def;
            var type = target.actionButton;
            if (type) {
                this.props.onEvent({ type: type, target: target });
            }
        }
        this.setInternalError(error);
    };
    DateControl.prototype.setInternalError = function (internalError) {
        this.setState({ internalError: internalError });
    };
    return DateControl;
}(FormBaseElement));
export { DateControl };
//# sourceMappingURL=Date.js.map